import { HeaderDesktop } from './HeaderDesktop';

export * from './HeaderDesktop';

export default HeaderDesktop;
